export default (theme) => ({
  pidsWrapper: {
    width: 'calc(100% - 50px)',
    height: 17,
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 35px)',
      height: 10,
    },
  },
  pid: {
    width: 'calc(100% / 8 - 10px)',
    height: 17,
    display: 'inline-block',
    borderRadius: 10,
    opacity: 0.5,
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% / 8 - 5px)',
      height: 10,
    },
  },
});
